import { computed, ComputedRef } from 'vue'
import { blockDefinitions } from '~/constants/blocks'
import { archiveBlockDefinitions } from '~/constants/blocks-archive'
import { sharedBlockDefinitions } from '~/constants/blocks-shared'
import { formDefinitions } from '~/constants/components-form'

export const useAllBlock = function (): ComputedRef {
  const allBlocks = computed(() => {
    const blocks = { ...blockDefinitions, ...archiveBlockDefinitions, ...formDefinitions }

    // add all shared blocks by key
    sharedBlockDefinitions.forEach((block) => {
      block.keys.forEach((key) => {
        blocks[key] = {
          component: block.component,
          fields: block.fields
        }
      })
    })

    return blocks
  })

  return allBlocks
}
